import type { UnionTypeLibelle } from "../../../techniques"

export const SousDispositif = [
  'ContratProfessionnalisation',
  'ContratProfessionnalisationExperimental',
  'Prodiat',
  'ContratProfessionnalisationHope'
] as const

export type SousDispositif = typeof SousDispositif[number]

/** Sous dispositifs disponibles à la créations */
export const SousDispositifDisponible: SousDispositif[] = [...new Set<SousDispositif>([
  'ContratProfessionnalisation',
  'ContratProfessionnalisationExperimental',
  'Prodiat',
  'ContratProfessionnalisationHope'
])] as const

export type SousDispositifDisponible = (typeof SousDispositifDisponible)[number]

export const SousDispositifLibelle: UnionTypeLibelle<SousDispositif> = {
  ContratProfessionnalisation: 'Contrat de Professionnalisation',
  ContratProfessionnalisationExperimental: 'Contrat de Professionnalisation expérimental',
  Prodiat: 'Contrat de Professionnalisation ProDiat',
  ContratProfessionnalisationHope: 'Contrat de Professionnalisation Hope',
} as const
